import request from '@apps-common/js-client/api/request';

import {normalizeError} from './util.js';

const SENTINEL_HUB_BASE = 'https://services.sentinel-hub.com';
const SENTINEL_HUB_ORDERS_URL = '/api/v1/dataimport/orders';

const sentinelHubInstance = request.create({
  baseURL: SENTINEL_HUB_BASE,
});

export const createSentinelHubOrder = async orders => {
  const results = [];
  for (const order of orders) {
    const result = await sentinelHubInstance
      .post(SENTINEL_HUB_ORDERS_URL, order)
      .then(async res => {
        // trackEvent('Order Placed Successfully', {
        //   orderName: order.name,
        //   itemType: order.products[0].item_type,
        //   productBundle: order.products[0].product_bundle,
        //   compositeType: toolsObjectToGroupType(order.tools),
        // });
        const order = res.data;
        return await sentinelHubInstance
          .post(`${SENTINEL_HUB_ORDERS_URL}/${order.id}/confirm`)
          .then(res => res.data)
          .catch(err => {
            return {
              ...order,
              error: err.response?.data.error,
            };
          });
      })
      .catch(err => {
        return {
          ...order,
          error: err.response?.data.error,
        };
      });

    // This is needed in order to avoid 429s from API
    // Promise.all would have the same issue and would need a similar
    // buffer between requests
    await setTimeout(500);

    results.push(result);
  }

  return results;
};

export const generateToken = async ({clientId, clientSecret}) => {
  return request
    .post(
      `${SENTINEL_HUB_BASE}/auth/realms/main/protocol/openid-connect/token`,
      {
        grant_type: 'client_credentials',
        client_id: clientId,
        client_secret: clientSecret,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    )
    .then(resp => {
      const accessToken = resp.data.access_token;

      Object.assign(sentinelHubInstance.defaults, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      return accessToken;
    });
};

export const getBYOCCollections = () => {
  return sentinelHubInstance
    .get('/api/v1/byoc/collections')
    .then(res => res.data)
    .catch(err => normalizeError(err));
};
